import React from 'react';
import './InfoSection.css';

// Import backgrounds
// NOTE: Replace .svg with .png when you add real texture images
import sectionBg1 from '../assets/backgrounds/section-bg-1.svg';
import sectionBg2 from '../assets/backgrounds/section-bg-2.svg';

// Ceremony icon (church/rings)
const CeremonyIcon = () => (
  <svg viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4L24 8" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <path d="M24 8C24 8 16 14 16 22V40H32V22C32 14 24 8 24 8Z" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 40V32C20 29.8 21.8 28 24 28C26.2 28 28 29.8 28 32V40" fill="none" stroke="currentColor" strokeWidth="2"/>
    <rect x="12" y="40" width="24" height="4" fill="currentColor" opacity="0.3"/>
  </svg>
);

// Reception icon (champagne glasses)
const ReceptionIcon = () => (
  <svg viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 8L12 24H20L16 8Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M16 24V32" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 32H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M32 8L28 24H36L32 8Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M32 24V32" stroke="currentColor" strokeWidth="2"/>
    <path d="M28 32H36" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 16C22 18 26 18 28 16" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
  </svg>
);

const InfoSection = ({
  type = 'ceremony', // 'ceremony' or 'reception'
  time,
  venue,
  address,
  note,
  description,
  timeline,
  directionsButtonLabel = 'Upute dolaska',
  parking,
  dietaryNote,
  mapsUrl = '#'
}) => {
  const hasTimeline = Array.isArray(timeline) && timeline.length > 0;
  const isCeremony = type === 'ceremony';
  const bgImage = isCeremony ? sectionBg1 : sectionBg2;
  const Icon = isCeremony ? CeremonyIcon : ReceptionIcon;
  const title = isCeremony ? 'Ceremonija' : 'Svečana večera';

  return (
    <section
      className={`info-section info-section--${type}`}
      aria-labelledby={`${type}-title`}
    >
      {/* Background texture */}
      <div
        className="info-section__bg-texture"
        style={{ backgroundImage: `url(${bgImage})` }}
        aria-hidden="true"
      />

      <div className="section-container info-section__content">
        {/* Venue Image Placeholder */}
        {/*<div className="info-section__image-wrapper">
          <div className="info-section__image-placeholder">
            <Icon />
            <span>{isCeremony ? 'Church Image' : 'Venue Image'}</span>
          </div>
        </div>*/}

        {/* Title */}
        <h2 id={`${type}-title`} className="info-section__title">
          {title}
        </h2>

        {/* Divider */}
        <div className="info-section__divider" aria-hidden="true" />

        {/* Optional Description */}
        {description && (
          <p className="info-section__description">{description}</p>
        )}

        {/* Optional Timeline (replaces Vrijeme grid item when present) */}
        {hasTimeline && (
          <ol className="info-section__timeline">
            {timeline.map((item, idx) => (
              <li key={idx} className="info-section__timeline-item">
                <div className="info-section__timeline-marker" aria-hidden="true">
                  <span className="info-section__timeline-dot" />
                  {idx < timeline.length - 1 && (
                    <span className="info-section__timeline-line" />
                  )}
                </div>
                <div className="info-section__timeline-body">
                  <p className="info-section__timeline-time">{item.time}</p>
                  {item.title && (
                    <p className="info-section__timeline-title">{item.title}</p>
                  )}
                  {item.description && (
                    <p className="info-section__timeline-description">{item.description}</p>
                  )}
                </div>
              </li>
            ))}
          </ol>
        )}

        {/* Details Grid */}
        <div className="info-section__details">
          {!hasTimeline && (
            <div className="info-section__detail-item">
              <p className="info-section__detail-label">Vrijeme</p>
              <p className="info-section__detail-value">{time}</p>
            </div>
          )}

          <div className="info-section__detail-item">
            <p className="info-section__detail-label">Mjesto</p>
            <p className="info-section__detail-value">{venue}</p>
          </div>

          <div
            className={`info-section__detail-item${
              hasTimeline ? '' : ' info-section__detail-item--full'
            }`}
          >
            <p className="info-section__detail-label">Lokacija</p>
            <p className="info-section__detail-value">{address}</p>
          </div>
        </div>

        {/* Get Directions Button */}
        <a
          href={mapsUrl}
          className="info-section__directions-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          {directionsButtonLabel}
        </a>

        {/* Optional Parking Info */}
        {parking && (parking.text || parking.mapsUrl) && (
          <div className="info-section__parking">
            {parking.text && (
              <p className="info-section__parking-text">{parking.text}</p>
            )}
            {parking.mapsUrl && (
              <a
                href={parking.mapsUrl}
                className="info-section__directions-btn info-section__parking-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {parking.buttonLabel || 'Lokacija parkinga'}
              </a>
            )}
          </div>
        )}

        {/* Optional dietary note */}
        {dietaryNote && (
          <p className="info-section__dietary-note">{dietaryNote}</p>
        )}

        {/* Optional Note */}
        {note && (
          <p className="info-section__note">{note}</p>
        )}

        {/* Adults Only Note - only show for reception */}
        {!isCeremony && (
          <p className="info-section__note"></p>
        )}
      </div>
    </section>
  );
};

export default InfoSection;
